import * as React from 'react';
import { SVGProps } from 'react';

const TeacherChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="85"
    height="85"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 85 85"
    {...props}
  >
    <defs>
      <clipPath id="clippath">
        <rect
          x="-31.18"
          y="-1038.28"
          width="1830.96"
          height="155.48"
          style={{ fill: 'none' }}
        />
      </clipPath>
      <clipPath id="clippath-1">
        <rect
          x="-62.44"
          y="-1462.51"
          width="1892.13"
          height="1230.77"
          style={{ fill: '#26a9df' }}
        />
      </clipPath>
    </defs>
    <g style={{ isolation: 'isolate' }}>
      <g id="Layer_1">
        <g style={{ clipPath: 'url(#clippath)' }}>
          <g>
            <rect
              x="-62.44"
              y="-1462.51"
              width="1892.13"
              height="1230.77"
              style={{ fill: '#26a9df' }}
            />
            <g style={{ clipPath: 'url(#clippath-1)' }}>
              <circle
                cx="883.62"
                cy="-505.27"
                r="961.34"
                style={{
                  fill: '#26a9df',
                  mixBlendMode: 'screen',
                  opacity: '.3',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <path d="m70.04,80.52c-.43,0-.87-.1-1.26-.32l-26.94-14.37H10.57c-4.44,0-8.05-3.61-8.05-8.05V16.53c0-4.44,3.61-8.05,8.05-8.05h63.86c4.44,0,8.05,3.61,8.05,8.05v41.24c0,4.44-3.61,8.05-8.05,8.05h-1.71v12c0,.94-.49,1.82-1.3,2.3-.42.26-.9.38-1.38.38ZM10.57,13.85c-1.48,0-2.68,1.2-2.68,2.68v41.24c0,1.48,1.2,2.68,2.68,2.68h31.93c.44,0,.87.11,1.26.32l23.59,12.58v-10.21c0-1.48,1.2-2.68,2.68-2.68h4.39c1.48,0,2.68-1.2,2.68-2.68V16.53c0-1.48-1.2-2.68-2.68-2.68H10.57Z" />
          <circle cx="22.7" cy="37.03" r="5.15" />
          <circle cx="42.5" cy="37.03" r="5.15" />
          <circle cx="62.38" cy="37.03" r="5.15" />
        </g>
      </g>
    </g>
  </svg>
);

export default TeacherChat;
